
const billPrintFromTableStyle = `
.container__billPrintFromTable {
    /*max-width:70vw;*/
    /*  max-height:70vh;*/
   /* background:#0000ff21;*/
   /* overflow: scroll;*/
    
}
/*  remove Padding To test */
/*
.container__billPrintFromTable td{
    padding:0.5rem;
}
.content .float {
    padding:0;
}
*/

.bill__logo {
    max-width: 50px;

}
table.body * {
    text-align: center;
}
b {
    font-weight: bold;
}
table {
    width: 100%;
}
.container {
    margin: 1rem;
} 
header.factor-header {
    display: flex;
    justify-content: space-between;
    margin-bottom:1.5rem;
}
th , td {
    border: 1px solid black;
    padding: 1rem;
}
thead tr th {
    width: 50%;
}
.float {
    display: flex;
}
.content .box {
    padding: 0.5rem;
    display: inline-block;
}
table.body {
    margin-top: 0.5rem;
}
.center {
    text-align: center;
    font-weight: bold;
}
.left{
    text-align: left !important;
}
@media print {
    main{
    padding: 1cm;
    }
}

`;
export default billPrintFromTableStyle
